import React, { useEffect } from "react";
import LoginContainer from './AccountLogin';
import {connect} from 'react-redux';
import {openModal, closeModal} from '../../Redux/actions/ui.js';
import { toggleEditorDocked, toggleRightDock, setActiveTab } from '../../Redux/actions/rightDock.js';
import { openEditorModalInDock } from './modalDocking.js';
import {removeAllFilters} from '../../Redux/actions/projectsFilters.js';
import { Link } from "react-router-dom";
import { selectPermissionCapabilities } from '../../utils/permissions.js';


function Button(props) {
  return (
    <div>
      <div className={"map-horizontal-button" + (props.disabled ? " disabled" : "") } onClick={props.onClick} title={props.title}>
        <span><i className="material-icons notranslate">{props.icon}</i>{props.name}</span>
      </div> 
    </div>
  )
}

function DropDownChoice(props) {
  return (
    <div className="edit-dropdown-entry" onClick={(e)=>{props.onClick()}}>
      <i className="material-icons notranslate">{props.icon}</i>{props.name}
    </div>
  )
}

const BackButton = (props) => {
  if (!props.hasVisitedHome) {
    return null;
  }

  return (
    <Link to="/">
      <div className={"map-horizontal-button back-home" + (props.logo ? " logo" : "")}>
        <span>
          <i className="material-icons notranslate">home</i>Back To All Projects
        </span>
      </div>
    </Link>
  );
};

const ClearFilter = (props) => {
  if (Object.keys(props.activeFilters).length == 0 || props.pageMode == "3D") {
    return null;
  }
  return (
    <div
      onClick={props.clearFilters}
      title="Clear Project Filters"
      className={"map-horizontal-button filter-button" + (props.logo ? " logo" : "")}>
      <span>
        <i className="material-icons notranslate">filter_alt</i>Clear Search Filters
      </span>
    </div>
  );
};

const AboutInventum3D = (props) => {
  const handleClick = (e) => {
    window.open("https://inventum3d.com/about", "_blank");
  }
  return (
    <Button
      icon={"info"}
      name={"About"}
      onClick={handleClick}
    />
  );
}

const AddProject = (props) => {
  const isModalTriggered = React.useRef(false);

  useEffect(() => {
    // Check session storage for the flag set by the static website
    const params = new URLSearchParams(window.location.search);
    const fromStaticButton = params.get('fromStaticButton');

    if (fromStaticButton === "true" && !isModalTriggered.current) {
      props.openModal("RegisterInterest");
      isModalTriggered.current = true;
      const newURL = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newURL);
    }
  }, [props]);

  // Don't show to admins
  if (props.siteAdmin) {
    return null;
  }

  // Show prominent call-to-action for non-admins
  return (
    <button 
      onClick={() => { props.openModal('RegisterInterest'); }} 
      className="AddProjectButton"
      aria-label="Add your project to Inventum"
    >
      <i className="material-icons notranslate">add_location</i>
      <span className="AddProjectButton-text">Add Your Project</span>
    </button>
  );
}

class EditInventumDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {open:false};
    this.dropdownRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({open: false});
    }
  }

  render() {
    let DropDownContainer = (props) => {
      return (
        <div className="editDropdownContainer">
          <DropDownChoice icon={"comment"} name={"Labels"} onClick={()=>{props.openEditorModalInDock("InventumLabelEditor")}} />
          <DropDownChoice icon={"tungsten"} name={"Lights"} onClick={()=>{props.openEditorModalInDock("InventumLightsEditor")}} />
          <DropDownChoice icon={"compare"} name={"Clipping"} onClick={()=>{props.openEditorModalInDock("InventumClippingEditor")}} />
          <DropDownChoice icon={"public"} name={"World"} onClick={()=>{props.openEditorModalInDock("InventumWorldEditor")}} />
          <DropDownChoice icon={"picture_in_picture"} name={"Slides (Legacy)"} onClick={()=>{props.openEditorModalInDock("InventumSlideEditor")}} />
        </div>
      )
    }

    return (
      <div ref={this.dropdownRef}>
        <div className={"map-horizontal-button"} onClick={()=>{this.props.openEditorModalInDock("InventumLabelEditor")}} title={"Edit"}>
          <span><i className="material-icons notranslate">edit</i>Edit</span>
          {this.state.open ? <DropDownContainer openEditorModalInDock={this.props.openEditorModalInDock} /> : null}
        </div>
      </div>
    )
  }
}

export function shouldHideViewerToolbar({ uiHideMode, rightDockVisible, pageMode } = {}) {
  return uiHideMode === "ALL" || uiHideMode === "ANIMATION" || (pageMode === "3D" && !!rightDockVisible);
}

//      <Button icon={"settings"} name={"Settings"} onClick={()=>{props.openModal("Settings")}} disabled={true} />
const ViewerButtons = (props) => {
  let showProjectEditor = false;
  let showProjectSearch = false;
  let showTenementDirectory = false;
  let showAnalytics = false;

  if (props.pageMode === "3D" && props.siteAdmin && props.editMode) {
    showProjectEditor = true;
  }

  if (props.pageMode === "2D" && props.activePageType === "COMPANY") {
    if (props.siteAdmin) {
      showAnalytics = true;
    } else {
      if (props.userCompanies) {
        props.userCompanies.map((company) => {
          if (company.id == props.activeCompanyID) {
            showAnalytics = true;
          }
        });
      }
    }
  }

  if (props.pageMode === "2D" && props.activePageType == "HOME") {
    showProjectSearch = true;
  }

  if (props.pageMode === "2D" && props.siteAdmin) {
    showTenementDirectory = true;
  }

  return (
    <div className={"viewer-toolbar" + (shouldHideViewerToolbar(props) ? " hidden" : "")}>
      {props.activePageType === "HOME" && <ClearFilter pageMode={props.pageMode} clearFilters={props.removeAllFilters} activeFilters={props.activeFilters} logo={props.logo} />}
      {showProjectEditor ? <EditInventumDropdown openEditorModalInDock={props.openEditorModalInDock} /> : null}
      {showProjectSearch ? <SearchButton siteAdmin={props.siteAdmin} openModal={props.openModal} /> : null}
      {showTenementDirectory ? (
        <Button
          icon={"account_balance"}
          name={"Tenements"}
          onClick={() => {
            props.openModal("TenementDirectory");
          }}
        />
      ) : null}
      {showAnalytics ? (
        <Button
          icon={"bar_chart"}
          name={"Analytics"}
          onClick={() => {
            props.openModal("AnalyticsDirectory");
          }}
        />
      ) : null}
      {props.pageMode === "3D" ? (
        <Button
          icon={"settings"}
          name={"Settings"}
          onClick={() => {
            props.openEditorModalInDock("SettingsEditor");
          }}
        />
      ) : null}
      <Button
        icon={"help"}
        name={"Help"}
        onClick={() => {
          if (props.pageMode === "3D") {
            props.openEditorModalInDock("HelpInfo");
          } else {
            props.openModal("HelpInfo");
          }
        }}
      />
      {<AboutInventum3D />}
      <LoginContainer />
      {props.activePageType === "COMPANY" && <BackButton hasVisitedHome={props.hasVisitedHome} logo={props.logo} />}
      <div className="viewer-toolbar-bottom">
        {props.pageMode === "2D" ? <AddProject openModal={props.openModal} siteAdmin={props.siteAdmin} /> : null}
      </div>
    </div>
  );
}

let mapDispatchToProps = dispatch => ({
  openModal:(modalName) => {
    dispatch(openModal(modalName));
  },
  removeAllFilters:() => {
    dispatch(removeAllFilters())
  },
  openEditorModalInDock:(modalName) => {
    openEditorModalInDock({
      modalName,
      toggleEditorDocked: (value) => dispatch(toggleEditorDocked(value)),
      toggleRightDock: (value) => dispatch(toggleRightDock(value)),
      setActiveTab: (value) => dispatch(setActiveTab(value)),
      openModal: (value) => dispatch(openModal(value))
    });
  }
})

let mapStateToProps = (state) => {
  const caps = selectPermissionCapabilities(state);

  return {
    siteAdmin: caps.isTrueSiteAdmin,
    activeModal:state.ui.activeModal,
    pageMode:state.sidebarUI.mode,
    editMode:state.ui.editMode,
    hasVisitedHome:state.ui.hasVisitedHome,
    uiHideMode: state.ui.hideMode,
    rightDockVisible: state.rightDock && state.rightDock.visible,
    activePageType:state.activePage.type,
    activeCompanyID:state.activePage.companyID,
    activeProjectID:state.activePage.projectID,
    userCompanies:state.user.companies,
    activeFilters:state.projectsFilters.active
  }
}

class SearchButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleShortcut = this.handleShortcut.bind(this);
  }

  componentDidMount () {
    window.addEventListener('keydown', this.handleShortcut);
  }

  componentWillUnmount () {
    window.removeEventListener('keydown', this.handleShortcut);
  }

  handleShortcut (e) {
    // Alt+S (Option+S on Mac) to open Search/Admin
    // Use e.code instead of e.key to avoid issues with Option key producing special characters on Mac
    if (e.altKey && e.code === 'KeyS') {
      this.props.openModal('ProjectDirectory');
      e.preventDefault();
      e.stopPropagation();
    }
  }

  render() {
    return (
      <Button icon={"search"} name={this.props.siteAdmin ? "Search/Admin" : "Search"} onClick={()=>{this.props.openModal("ProjectDirectory")}} />
    )
  }

}

const ViewerButtonsContainer = connect(mapStateToProps, mapDispatchToProps)(ViewerButtons)


export default ViewerButtonsContainer;
